module.exports = __webpack_public_path__ + "static/img/member08.7ae236c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member08.png
// module id = q5eE
// module chunks = 0